

export const CustomButtonInForm = ({column, postSuccessAction}) => {
    return <div className="non-selectable" style={{
        width: '100%', 
        marginTop: '2rem', 
        padding: '0.9rem', 
        textAlign: 'center', 
        color: column.textColor || 'white', 
        fontWeight: 'bold',
        fontSize: 'var(--font-post-medium)',
        cursor: 'pointer',
        backgroundColor: column.bgColor, borderRadius: '8px'}} onClick={()=>{column.action(postSuccessAction)}}>
        {column.buttonLabel}
    </div>
}